import * as React from 'react';
import styled from 'styled-components';
import ActionMenu, { ActionMenuItem } from './ActionMenu';
import { PlainButton } from './styled-components';

const Wrapper = styled.div``;

const ToggleButton = styled(PlainButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const Title = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 20px;
`;

interface Props {
  title: React.ReactNode;
  items: ActionMenuItem[];
  header?: React.ReactNode;
  footer?: React.ReactNode;
  align?: 'start' | 'end';
  className?: string;
}

export default function MenuDropdown({
  title,
  items,
  header = null,
  footer = null,
  align = 'start',
  className = undefined,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleMenu = React.useCallback(() => {
    setIsOpen((open) => !open);
  }, []);

  const parentElementRef = React.useRef<HTMLDivElement>();

  return (
    <Wrapper className={className} ref={parentElementRef as React.RefObject<HTMLDivElement>}>
      <ActionMenu
        isOpen={isOpen}
        items={items}
        header={header}
        footer={footer}
        className={`${className}__menu`}
        positions={['bottom', 'left', 'right', 'top']}
        align={align}
        onClose={toggleMenu}
        parentElement={parentElementRef.current}
      >
        <ToggleButton onClick={toggleMenu} aria-haspopup="menu" aria-expanded={isOpen}>
          <Title>{title}</Title>
          <svg width="14" height="8" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
            <path
              d="M1 1l6 6 6-6"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </ToggleButton>
      </ActionMenu>
    </Wrapper>
  );
}
